import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { Subscription } from "rxjs";
import { ThemeService } from "../theme/theme-service.service";

@Component({
    selector: "app-request-access",
    templateUrl: "./request-access.component.html",
    styleUrls: ["./request-access.component.scss"],
    standalone: false
})
export class RequestAccessComponent implements OnInit {
  public clientId;
  public subscription: Subscription;
  public sharedPlan: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.clientId = params.get("Id");
    });
  }

  ngOnInit() {
    this.subscription = this.getInfoAndPassService.accessRightSection.subscribe(
      (data) => {
        this.sharedPlan = data;
      }
    );
  }

  onSelect() {
    this.getInfoAndPassService.getInfoAndPass(this.sharedPlan);
    this.router.navigate(["/request-access-plan/" + this.clientId]);
  }
}
